import PropTypes from 'prop-types';
import {createContext, useEffect, useState} from 'react';

export const FilterContext = createContext();

const DEFAULT_FILTERS = {
  brands: [],
  productCategories: [],
  features: [],
  colors: [],
  minPrice: '',
  maxPrice: '',
};

const getInitialFilters = () => {
  try {
    const stored = JSON.parse(localStorage.getItem('filters')) || {};

    return {
      brands: Array.isArray(stored.brands) ? stored.brands : [],
      productCategories: Array.isArray(stored.productCategories)
        ? stored.productCategories
        : [],
      features: Array.isArray(stored.features) ? stored.features : [],
      colors: Array.isArray(stored.colors) ? stored.colors : [],
      minPrice: stored.minPrice ?? '',
      maxPrice: stored.maxPrice ?? '',
    };
  } catch {
    return {...DEFAULT_FILTERS};
  }
};

const FilterProvider = ({children}) => {
  const [filters, setFilters] = useState(getInitialFilters);

  useEffect(() => {
    const normalized = {
      brands: Array.isArray(filters.brands) ? filters.brands : [],
      productCategories: Array.isArray(filters.productCategories)
        ? filters.productCategories
        : [],
      features: Array.isArray(filters.features) ? filters.features : [],
      colors: Array.isArray(filters.colors) ? filters.colors : [],
      minPrice: filters.minPrice ?? '',
      maxPrice: filters.maxPrice ?? '',
    };

    // If anything was invalid, fix state
    if (JSON.stringify(normalized) !== JSON.stringify(filters)) {
      setFilters(normalized);
      localStorage.setItem('filters', JSON.stringify(normalized));
      return;
    }

    localStorage.setItem('filters', JSON.stringify(filters));
  }, [filters]);

  const resetFilters = () => {
    setFilters({...DEFAULT_FILTERS});
    localStorage.removeItem('filters');
  };

  return (
    <FilterContext.Provider value={{filters, setFilters, resetFilters}}>
      {children}
    </FilterContext.Provider>
  );
};

FilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export {FilterProvider};
